var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.newServer
        ? _c(
            "p",
            {
              staticClass: "kvm-help text-caption mb-3"
            },
            [
              _vm._v(
                "Pick the app and answer a few questions about it — you choose which server it runs on next."
              )
            ]
          )
        : _c(
            "p",
            {
              staticClass: "kvm-help text-caption mb-3"
            },
            [
              _vm._v(
                "Pick a ready-made app to install in one click, or set up your own from a docker-compose file."
              )
            ]
          ),
      _vm.error
        ? _c(
            "v-alert",
            {
              attrs: {
                type: "error",
                border: "left",
                dense: "",
                role: "alert"
              }
            },
            [_vm._v(_vm._s(_vm.error))]
          )
        : _vm._e(),
      _vm.loading
        ? _c(
            "div",
            {
              staticClass: "py-6 text-center",
              attrs: {
                role: "status"
              }
            },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  color: "primary",
                  size: "32",
                  width: "3"
                }
              }),
              _c(
                "span",
                {
                  staticClass: "kvm-sr-only"
                },
                [_vm._v("Loading templates…")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.groups, function(group) {
        return _c(
          "div",
          {
            key: group.name,
            staticClass: "mb-4"
          },
          [
            _c(
              "div",
              {
                staticClass: "subtitle-2 mb-2"
              },
              [_vm._v(_vm._s(group.name))]
            ),
            _c(
              "v-row",
              {
                attrs: {
                  dense: ""
                }
              },
              _vm._l(group.items, function(t) {
                return _c(
                  "v-col",
                  {
                    key: t.slug,
                    attrs: {
                      cols: "12",
                      sm: "6",
                      md: "4"
                    }
                  },
                  [
                    _c(
                      "gg-card",
                      {
                        staticClass: "kvm-dk-tile",
                        attrs: {
                          tabindex: "0",
                          role: "button",
                          "aria-label": "Install " + t.name
                        },
                        nativeOn: {
                          click: function click($event) {
                            return _vm.openDeploy(t)
                          },
                          keydown: [
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.openDeploy(t)
                            },
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "space",
                                  32,
                                  $event.key,
                                  [" ", "Spacebar"]
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.openDeploy(t)
                            }
                          ]
                        }
                      },
                      [
                        _c(
                          "gg-card-text",
                          {
                            staticClass: "d-flex align-start pa-3"
                          },
                          [
                            _c("kvm-logo", {
                              staticClass: "mr-3",
                              attrs: {
                                item: t,
                                size: 32,
                                "default-icon": "mdi-docker"
                              }
                            }),
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "body-2 font-weight-medium"
                                },
                                [_vm._v(_vm._s(t.name))]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "kvm-help text-caption"
                                },
                                [_vm._v(_vm._s(t.description))]
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              1
            )
          ],
          1
        )
      }),
      !_vm.loading
        ? _c(
            "div",
            {
              staticClass: "mb-2"
            },
            [
              _c(
                "div",
                {
                  staticClass: "subtitle-2 mb-2"
                },
                [_vm._v("Custom")]
              ),
              _c(
                "v-row",
                {
                  attrs: {
                    dense: ""
                  }
                },
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        sm: "6",
                        md: "4"
                      }
                    },
                    [
                      _c(
                        "gg-card",
                        {
                          staticClass: "kvm-dk-tile",
                          attrs: {
                            tabindex: "0",
                            role: "button",
                            "aria-label":
                              "Custom app from a docker-compose file"
                          },
                          nativeOn: {
                            click: function click($event) {
                              return _vm.openCustom($event)
                            },
                            keydown: [
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.openCustom($event)
                              },
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.openCustom($event)
                              }
                            ]
                          }
                        },
                        [
                          _c(
                            "gg-card-text",
                            {
                              staticClass: "d-flex align-start pa-3"
                            },
                            [
                              _c("kvm-logo", {
                                staticClass: "mr-3",
                                attrs: {
                                  item: {
                                    icon: "mdi-file-code-outline"
                                  },
                                  size: 32
                                }
                              }),
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "body-2 font-weight-medium"
                                  },
                                  [_vm._v("Custom app")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "kvm-help text-caption"
                                  },
                                  [
                                    _vm._v(
                                      "Paste your own docker-compose file — for anything not listed here."
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "560",
            persistent: ""
          },
          model: {
            value: _vm.deploy.open,
            callback: function callback($$v) {
              _vm.$set(_vm.deploy, "open", $$v)
            },
            expression: "deploy.open"
          }
        },
        [
          _vm.deploy.t
            ? _c(
                "gg-card",
                {
                  attrs: {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "kvm-dk-tpl-title"
                  }
                },
                [
                  _c(
                    "gg-card-text",
                    {
                      staticClass: "pa-4"
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticClass: "body-1 font-weight-medium mb-3",
                          attrs: {
                            id: "kvm-dk-tpl-title"
                          }
                        },
                        [_vm._v("Install " + _vm._s(_vm.deploy.t.name))]
                      ),
                      _vm.deploy.result
                        ? [
                            _c(
                              "v-alert",
                              {
                                staticClass: "mb-3",
                                attrs: {
                                  type: "success",
                                  dense: "",
                                  text: ""
                                }
                              },
                              [
                                _vm._v(
                                  " Installation started — follow its progress at the top of this page. "
                                )
                              ]
                            ),
                            _vm.deploy.result.route
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "mb-3"
                                  },
                                  [
                                    _vm._v(" It will be available at "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "kvm-dk-link",
                                        attrs: {
                                          href: _vm.routeUrl(
                                            _vm.deploy.result.route
                                          ),
                                          target: "_blank",
                                          rel: "noopener"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.routeUrl(
                                              _vm.deploy.result.route
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      " once it has started (HTTPS is set up on the first visit). "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm.generatedList.length
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "mb-3"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "subtitle-2 mb-1"
                                      },
                                      [
                                        _vm._v(
                                          "Generated for you — also kept on this app's Manage page (under Apps)"
                                        )
                                      ]
                                    ),
                                    _vm._l(_vm.generatedList, function(g) {
                                      return _c(
                                        "div",
                                        {
                                          key: g.key,
                                          staticClass:
                                            "d-flex align-center mb-1"
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "kvm-help text-caption mr-2",
                                              staticStyle: {
                                                "min-width": "140px"
                                              }
                                            },
                                            [_vm._v(_vm._s(g.label))]
                                          ),
                                          _c("kvm-copyable", {
                                            attrs: {
                                              value: g.value,
                                              display: g.value
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    })
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.postDeployHtml
                              ? _c("div", {
                                  staticClass: "kvm-dk-md mb-2",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.postDeployHtml)
                                  }
                                })
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "text-right"
                              },
                              [
                                _vm.deploy.t.device_pairing
                                  ? _c(
                                      "gg-btn",
                                      {
                                        staticClass: "mr-2",
                                        attrs: {
                                          tile: "",
                                          outlined: "",
                                          color: "primary"
                                        },
                                        on: {
                                          click: function click($event) {
                                            _vm.pairingOpen = true
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              left: "",
                                              small: "",
                                              "aria-hidden": "true"
                                            }
                                          },
                                          [_vm._v("mdi-check-decagram")]
                                        ),
                                        _vm._v("Approve my browser ")
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "gg-btn",
                                  {
                                    staticClass: "kvm-dk-primary",
                                    attrs: {
                                      tile: "",
                                      color: "primary"
                                    },
                                    on: {
                                      click: _vm.finish
                                    }
                                  },
                                  [_vm._v("Done")]
                                )
                              ],
                              1
                            )
                          ]
                        : [
                            _c("v-text-field", {
                              staticClass: "mb-3",
                              attrs: {
                                label: "App name",
                                outlined: "",
                                dense: "",
                                hint:
                                  "How it is listed under Apps. Lowercase letters, numbers, - and _; must not already exist.",
                                "persistent-hint": ""
                              },
                              on: {
                                input: _vm.onStackInput
                              },
                              model: {
                                value: _vm.deploy.stack,
                                callback: function callback($$v) {
                                  _vm.$set(
                                    _vm.deploy,
                                    "stack",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "deploy.stack"
                              }
                            }),
                            _vm.newServer && _vm.webPortKey(_vm.deploy.t)
                              ? [
                                  _c("v-checkbox", {
                                    staticClass: "mt-0 mb-2",
                                    attrs: {
                                      dense: "",
                                      "hide-details": "",
                                      disabled: _vm.deploy.t.requires_domain,
                                      label: "Publish at a domain with HTTPS"
                                    },
                                    model: {
                                      value: _vm.deploy.publish,
                                      callback: function callback($$v) {
                                        _vm.$set(_vm.deploy, "publish", $$v)
                                      },
                                      expression: "deploy.publish"
                                    }
                                  }),
                                  _vm.deploy.publish
                                    ? [
                                        _c(
                                          "v-radio-group",
                                          {
                                            staticClass: "mt-0 mb-2",
                                            attrs: {
                                              row: "",
                                              dense: "",
                                              "hide-details": ""
                                            },
                                            model: {
                                              value: _vm.deploy.domainKind,
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.deploy,
                                                  "domainKind",
                                                  $$v
                                                )
                                              },
                                              expression: "deploy.domainKind"
                                            }
                                          },
                                          [
                                            _c("v-radio", {
                                              attrs: {
                                                label: "Free domain",
                                                value: "free"
                                              }
                                            }),
                                            _c("v-radio", {
                                              attrs: {
                                                label: "One of my domains",
                                                value: "mine"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm.deploy.domainKind === "free"
                                          ? _c("v-text-field", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                label: "Subdomain",
                                                outlined: "",
                                                dense: "",
                                                "persistent-hint": "",
                                                suffix:
                                                  "." +
                                                  _vm.freeDomainPlaceholder,
                                                hint: _vm.freeDomainBase
                                                  ? "xxxxxxxx is your server’s own part of the address — filled in once you pick the server. You can add your own domain later."
                                                  : "Each app gets its own address on its server’s free domain — shown once you pick the server. You can add your own domain later."
                                              },
                                              on: {
                                                input: _vm.onSubdomainInput
                                              },
                                              model: {
                                                value: _vm.deploy.domainName,
                                                callback: function callback(
                                                  $$v
                                                ) {
                                                  _vm.$set(
                                                    _vm.deploy,
                                                    "domainName",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "deploy.domainName"
                                              }
                                            })
                                          : _c("kvm-own-domain", {
                                              attrs: {
                                                "app-name": _vm.deploy.stack
                                              },
                                              model: {
                                                value: _vm.deploy.mine,
                                                callback: function callback(
                                                  $$v
                                                ) {
                                                  _vm.$set(
                                                    _vm.deploy,
                                                    "mine",
                                                    $$v
                                                  )
                                                },
                                                expression: "deploy.mine"
                                              }
                                            })
                                      ]
                                    : _vm._e()
                                ]
                              : _vm.proxy &&
                                _vm.proxy.installed &&
                                _vm.webPortKey(_vm.deploy.t)
                              ? [
                                  _c("v-checkbox", {
                                    staticClass: "mt-0 mb-2",
                                    attrs: {
                                      dense: "",
                                      "hide-details": "",
                                      label: "Publish at a domain with HTTPS"
                                    },
                                    model: {
                                      value: _vm.deploy.publish,
                                      callback: function callback($$v) {
                                        _vm.$set(_vm.deploy, "publish", $$v)
                                      },
                                      expression: "deploy.publish"
                                    }
                                  }),
                                  _vm.deploy.publish
                                    ? [
                                        _c(
                                          "v-radio-group",
                                          {
                                            staticClass: "mt-0 mb-2",
                                            attrs: {
                                              row: "",
                                              dense: "",
                                              "hide-details": ""
                                            },
                                            on: {
                                              change: _vm.suggestPath
                                            },
                                            model: {
                                              value: _vm.deploy.domainKind,
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.deploy,
                                                  "domainKind",
                                                  $$v
                                                )
                                              },
                                              expression: "deploy.domainKind"
                                            }
                                          },
                                          [
                                            _vm.proxy.free_domain
                                              ? _c("v-radio", {
                                                  attrs: {
                                                    label: "Free domain",
                                                    value: "free"
                                                  }
                                                })
                                              : _vm._e(),
                                            _c("v-radio", {
                                              attrs: {
                                                label: "One of my domains",
                                                value: "mine"
                                              }
                                            }),
                                            _c("v-radio", {
                                              attrs: {
                                                label: "Another domain",
                                                value: "own"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm.deploy.domainKind === "free" &&
                                        _vm.proxy.free_domain
                                          ? _c("v-text-field", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                label: "Subdomain",
                                                outlined: "",
                                                dense: "",
                                                "persistent-hint": "",
                                                suffix:
                                                  "." + _vm.proxy.free_domain,
                                                hint:
                                                  "Each app gets its own address, so several apps can share this server."
                                              },
                                              on: {
                                                input: _vm.onSubdomainInput
                                              },
                                              model: {
                                                value: _vm.deploy.domainName,
                                                callback: function callback(
                                                  $$v
                                                ) {
                                                  _vm.$set(
                                                    _vm.deploy,
                                                    "domainName",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "deploy.domainName"
                                              }
                                            })
                                          : _vm.deploy.domainKind === "mine"
                                          ? _c("kvm-own-domain", {
                                              attrs: {
                                                "app-name": _vm.deploy.stack,
                                                "server-ip": _vm.proxy.server_ip
                                              },
                                              model: {
                                                value: _vm.deploy.mine,
                                                callback: function callback(
                                                  $$v
                                                ) {
                                                  _vm.$set(
                                                    _vm.deploy,
                                                    "mine",
                                                    $$v
                                                  )
                                                },
                                                expression: "deploy.mine"
                                              }
                                            })
                                          : _c("v-text-field", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                label: "Domain",
                                                placeholder: "blog.example.com",
                                                outlined: "",
                                                dense: "",
                                                "persistent-hint": "",
                                                hint:
                                                  "Point its DNS A record to " +
                                                  _vm.proxy.server_ip
                                              },
                                              on: {
                                                input: _vm.suggestPath
                                              },
                                              model: {
                                                value: _vm.deploy.domainOwn,
                                                callback: function callback(
                                                  $$v
                                                ) {
                                                  _vm.$set(
                                                    _vm.deploy,
                                                    "domainOwn",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "deploy.domainOwn"
                                              }
                                            }),
                                        _c("v-text-field", {
                                          staticClass: "mb-2",
                                          attrs: {
                                            label: "Path",
                                            placeholder: "/",
                                            outlined: "",
                                            dense: "",
                                            "persistent-hint": "",
                                            hint:
                                              "/ is the whole domain. Use a path like /wordpress2 to put several apps on one domain."
                                          },
                                          on: {
                                            input: function input($event) {
                                              _vm.deploy.autoPath = false
                                            }
                                          },
                                          model: {
                                            value: _vm.deploy.domainPath,
                                            callback: function callback($$v) {
                                              _vm.$set(
                                                _vm.deploy,
                                                "domainPath",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "deploy.domainPath"
                                          }
                                        }),
                                        _vm.deployHostname()
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "kvm-help text-caption mt-n1 mb-3"
                                              },
                                              [
                                                _vm._v(" It will be at "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.routeUrl({
                                                        hostname: _vm.deployHostname(),
                                                        path:
                                                          _vm.deploy.domainPath
                                                      })
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    : _vm._e()
                                ]
                              : _vm._e(),
                            _vm._l(_vm.visibleVariables, function(v) {
                              return _c(
                                "div",
                                {
                                  key: v.key
                                },
                                [
                                  v.type === "select"
                                    ? _c("v-select", {
                                        staticClass: "mb-2",
                                        attrs: {
                                          items: (v.choices || []).map(function(
                                            c
                                          ) {
                                            return {
                                              text: c.label,
                                              value: c.value
                                            }
                                          }),
                                          label:
                                            v.label + (v.required ? " *" : ""),
                                          hint: v.help,
                                          "persistent-hint": "",
                                          outlined: "",
                                          dense: ""
                                        },
                                        model: {
                                          value: _vm.deploy.values[v.key],
                                          callback: function callback($$v) {
                                            _vm.$set(
                                              _vm.deploy.values,
                                              v.key,
                                              $$v
                                            )
                                          },
                                          expression: "deploy.values[v.key]"
                                        }
                                      })
                                    : _c("v-text-field", {
                                        staticClass: "mb-2",
                                        attrs: {
                                          label:
                                            v.label + (v.required ? " *" : ""),
                                          type:
                                            _vm.isSecret(v) &&
                                            !_vm.deploy.reveal[v.key]
                                              ? "password"
                                              : v.type === "number"
                                              ? "number"
                                              : "text",
                                          hint:
                                            v.help ||
                                            (v.type === "password_generate"
                                              ? "Leave blank to generate a strong one."
                                              : ""),
                                          "persistent-hint": "",
                                          outlined: "",
                                          dense: "",
                                          autocomplete: "new-password"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            _vm.isSecret(v)
                                              ? {
                                                  key: "append",
                                                  fn: function fn() {
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            "aria-label": _vm
                                                              .deploy.reveal[
                                                              v.key
                                                            ]
                                                              ? "Hide"
                                                              : "Show"
                                                          },
                                                          on: {
                                                            click: function click(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.deploy
                                                                  .reveal,
                                                                v.key,
                                                                !_vm.deploy
                                                                  .reveal[v.key]
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.deploy
                                                                  .reveal[v.key]
                                                                  ? "mdi-eye-off"
                                                                  : "mdi-eye"
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              : null
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: _vm.deploy.values[v.key],
                                          callback: function callback($$v) {
                                            _vm.$set(
                                              _vm.deploy.values,
                                              v.key,
                                              $$v
                                            )
                                          },
                                          expression: "deploy.values[v.key]"
                                        }
                                      })
                                ],
                                1
                              )
                            }),
                            _vm.deploy.error
                              ? _c(
                                  "v-alert",
                                  {
                                    staticClass: "mb-0",
                                    attrs: {
                                      type: "warning",
                                      dense: "",
                                      text: "",
                                      role: "alert"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.deploy.error))]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "text-right mt-3"
                              },
                              [
                                _c(
                                  "gg-btn",
                                  {
                                    staticClass: "mr-2",
                                    attrs: {
                                      text: "",
                                      disabled: _vm.deploy.submitting
                                    },
                                    on: {
                                      click: function click($event) {
                                        _vm.deploy.open = false
                                      }
                                    }
                                  },
                                  [_vm._v("Cancel")]
                                ),
                                _c(
                                  "gg-btn",
                                  {
                                    staticClass: "kvm-dk-primary",
                                    attrs: {
                                      tile: "",
                                      color: "primary",
                                      loading: _vm.deploy.submitting,
                                      disabled: !_vm.deploy.stack
                                    },
                                    on: {
                                      click: _vm.doDeploy
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.newServer ? "Continue" : "Install"
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      !_vm.newServer && _vm.deploy.t && _vm.deploy.t.device_pairing
        ? _c("kvm-docker-pairing", {
            attrs: {
              "service-id": _vm.serviceId,
              stack: _vm.deploy.stack,
              "app-name": _vm.deploy.t.name
            },
            model: {
              value: _vm.pairingOpen,
              callback: function callback($$v) {
                _vm.pairingOpen = $$v
              },
              expression: "pairingOpen"
            }
          })
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "900",
            persistent: ""
          },
          model: {
            value: _vm.custom.open,
            callback: function callback($$v) {
              _vm.$set(_vm.custom, "open", $$v)
            },
            expression: "custom.open"
          }
        },
        [
          _c(
            "gg-card",
            {
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "kvm-dk-custom-title"
              }
            },
            [
              _c(
                "gg-card-text",
                {
                  staticClass: "pa-4"
                },
                [
                  _c(
                    "h3",
                    {
                      staticClass: "body-1 font-weight-medium mb-3",
                      attrs: {
                        id: "kvm-dk-custom-title"
                      }
                    },
                    [_vm._v("Custom app")]
                  ),
                  _c("v-text-field", {
                    staticClass: "mb-3",
                    attrs: {
                      label: "App name",
                      outlined: "",
                      dense: "",
                      hint: "Lowercase letters, numbers, - and _ (e.g. my-app)",
                      "persistent-hint": ""
                    },
                    model: {
                      value: _vm.custom.stack,
                      callback: function callback($$v) {
                        _vm.$set(
                          _vm.custom,
                          "stack",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "custom.stack"
                    }
                  }),
                  _c("v-textarea", {
                    staticClass: "kvm-dk-code",
                    attrs: {
                      label: "docker-compose.yml",
                      outlined: "",
                      rows: "16",
                      spellcheck: "false",
                      autocomplete: "off",
                      placeholder: _vm.composePlaceholder
                    },
                    model: {
                      value: _vm.custom.compose,
                      callback: function callback($$v) {
                        _vm.$set(_vm.custom, "compose", $$v)
                      },
                      expression: "custom.compose"
                    }
                  }),
                  _vm.custom.error
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mb-0",
                          attrs: {
                            type: "warning",
                            dense: "",
                            text: "",
                            role: "alert"
                          }
                        },
                        [_vm._v(_vm._s(_vm.custom.error))]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "text-right mt-3"
                    },
                    [
                      _c(
                        "gg-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            text: ""
                          },
                          on: {
                            click: function click($event) {
                              _vm.custom.open = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          staticClass: "kvm-dk-primary",
                          attrs: {
                            tile: "",
                            color: "primary",
                            disabled:
                              !_vm.custom.stack || !_vm.custom.compose.trim()
                          },
                          on: {
                            click: _vm.chooseCustom
                          }
                        },
                        [_vm._v(" Continue ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }